import {getCookie} from '@daedalus/core/src/utils/cookies'

const setRezServerFraudProtectionHeader = axiosInstance => {
  const token = getCookie('RS-CLIENT')

  /* eslint-disable */
  axiosInstance.defaults.headers.common['X-FP-Token'] = token
}

export default setRezServerFraudProtectionHeader